export default "__VITE_ASSET__Dgr0hGeA__"